import { getClasses } from '@/_utils/classnames';
import styles from './CardPagination.module.css';
import type { CardPaginationProps } from './CardPagination.types';
import type { FC } from 'react';
import { Flex } from '@/_components';

export const CardPagination: FC<CardPaginationProps> = ({
  children,
  isHidden,
}) => {
  if (isHidden) return null;

  const cardPaginationClasses: string = getClasses(styles.cardPagination, {});

  return (
    <Flex className={cardPaginationClasses} isCentered={true}>
      {children}
    </Flex>
  );
};
